export default __webpack_public_path__ + "static/media/icon_radio_button_checked_dark.a74fa6fb.svg";